import React, { useEffect, useState } from "react";
import LibrarySidebarComponent from '../LibrarySidebarComponent';
import { getAllData } from "../../../Utils/firebaseServices";
import LoadingCircular from "../../../loader/LoadingCircular";

function Library() {
    const [libraryTabData, setLibraryTabData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                await getAllData(
                    "library_sidebar_categories_collection",
                    setLibraryTabData
                );
            } catch (error) {
                console.error("Error fetching data", error);
            } finally {
                setLoading(false);
            }
        };
        fetchData();
    }, []);

    if (loading) {
        return <LoadingCircular />;
    }
    return (
        <>
            <LibrarySidebarComponent data={libraryTabData} />
        </>
    )
}

export default Library